import React from "react";
import { FaqResourcePage } from "../components/FaqResourcePage";
import { CALENDLY_URL, CAPITAL_MARKETS_FAQ_SECTIONS } from "../data/content";

const CapitalMarketsFaq = () => (
  <FaqResourcePage
    pageTestId="capital-markets-faq-page"
    kicker="Capital Markets Consulting FAQs"
    h1Lines={[
      <span key="a">Capital markets consulting —</span>,
      <span key="b">
        your questions <em className="italic text-[#3E9BDC]">answered.</em>
      </span>,
    ]}
    intro={
      <>
        Raising capital requires a coordinated view of product structure, target investors, diligence
        expectations, distribution strategy and operating economics. These answers address common
        questions from private-fund sponsors and market participants building or refining an offering.
        American Elm Advisors provides capital markets consulting designed to help management make
        practical, better-informed decisions. The work is tailored to the sponsor's strategy, offering
        and target market, and is coordinated with counsel, administrators, transfer agents and other
        appropriate providers.
      </>
    }
    primaryCta={{ label: "Discuss your next offering", to: "/contact?topic=Capital%20Markets%20Consulting" }}
    sections={CAPITAL_MARKETS_FAQ_SECTIONS}
    inlineCta={{
      afterSectionId: "distribution-and-diligence",
      body: "Structuring or refining an offering? Tell us where you are and we'll help you map the next step.",
      buttonLabel: "Discuss your situation",
      to: "/contact?topic=Capital%20Markets%20Consulting",
      eventName: "faq_inline_capital",
    }}
    closing={{
      heading: "Discuss your next offering.",
      body: "Whether you are structuring a first fund or refining distribution for an existing strategy, we can help you assess the next step.",
      primary: { label: "Request a consultation", to: "/contact?topic=Capital%20Markets%20Consulting" },
      secondary: { label: "Schedule a 15-minute call", to: CALENDLY_URL, external: true },
    }}
    related={[
      { label: "Compliance consulting", to: "/compliance-consulting" },
      { label: "Trust services consulting", to: "/trust-services-consulting" },
      { label: "AML independent audits", to: "/aml-independent-audits" },
    ]}
  />
);

export default CapitalMarketsFaq;
